import * as React from 'react'

function SvgFireExtinguisherUnchecked(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="inherit"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path d="m29 12.414-2.293 2.293-1.414-1.414L27.586 11l-2.293-2.293 1.414-1.414L29 9.586l2.293-2.293 1.414 1.414L30.414 11l2.293 2.293-1.414 1.414L29 12.414Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29 3a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-6 8a6 6 0 1 0 12 0 6 6 0 0 0-12 0Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.512 14a8.98 8.98 0 0 0 1.32 2.443A3.998 3.998 0 0 0 16.535 18h6.808a8.984 8.984 0 0 0 2.635 1.48c.014.171.022.345.022.52v12H14V20c0-2.22 1.207-4.16 3-5.197v-.623l-6 1V8.82l6.225 1.037a3 3 0 0 1 3.273-1.816 8.943 8.943 0 0 0-.443 1.96A1 1 0 0 0 19 11v1.99l.02.855-.02.003V14h1.512ZM24 28v2h-8v-2h8Zm0-2v-6h-8v6h8Zm-7.027-14.157L13 11.18v1.639l3.98-.664-.007-.313Z"
      />
    </svg>
  )
}

export default SvgFireExtinguisherUnchecked
